<!-- @format -->

<template>
	<el-rate v-model="value" class="rate" />
</template>

<script setup lang="ts">
	interface Props {
		modelValue: number | null;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue === 0 ? 0 : props.modelValue ? +props.modelValue : undefined;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped>
	.rate {
		flex-wrap: wrap;
	}
</style>
